import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    data: Array,
    layout: Object,
    displayTimezone: String,
  };

  connect() {
    Plotly.newPlot(this.element, this.dataValue, this.layoutValue);
    this.startNowLineUpdater();
  }

  disconnect() {
    if (this.nowLineInterval) {
      clearInterval(this.nowLineInterval);
    }
  }

  startNowLineUpdater() {
    this.nowLineInterval = setInterval(() => {
      this.updateNowLine();
    }, 2000);
    
    setTimeout(() => {
      this.updateNowLine();
    }, 100);
  }

  updateNowLine() {
    const displayTimezone = this.displayTimezoneValue || 'UTC';
    
    const now = new Date().toLocaleString('nl-NL', {
      timeZone: displayTimezone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).replace(' ', 'T');
    
    const updatedShapes = this.layoutValue.shapes?.map(shape => ({
      ...shape,
      x0: now,
      x1: now
    })) || [];

    const updatedAnnotations = this.layoutValue.annotations?.map(annotation => ({
      ...annotation,
      x: now
    })) || [];

    Plotly.relayout(this.element, {
      shapes: updatedShapes,
      annotations: updatedAnnotations
    });
  }
}
